import React, { Suspense, useState, useEffect } from 'react';
import { useClipboardBlock } from './../pages/hooks/useClipboardBlock'; // Path import tetap sama

const Section = React.lazy(() => import('./section'))
const NavbarPage = React.lazy(() => import('../components/Navbar'))
const About = React.lazy(() => import('../components/About'))
const FormRegister = React.lazy(() => import('./RegistrationPage'))
const Footer = React.lazy(() => import('../components/Footer'))

const Index = () => {
    // 1. Panggil custom hook di sini (langsung di dalam komponen)
    useClipboardBlock();

    // 2. Gunakan useState sebagai pengganti this.state
    const [navItems] = useState([
        { id: 1, idnm: 'home', navheading: 'Home' },
        { id: 2, idnm: 'about', navheading: 'About' },
        { id: 3, idnm: 'register', navheading: 'Register' },
    ]);
    const [navClass, setNavClass] = useState("");
    const [imglight, setImglight] = useState(true);

    // 3. Gunakan useEffect sebagai pengganti componentDidMount dan componentWillUnmount
    useEffect(() => {
        const initialPos = document.documentElement.scrollTop;

        const scrollNavigation = () => {
            const scrollup = document.documentElement.scrollTop;
            if (scrollup > initialPos) {
                setNavClass("darkheader");
                setImglight(false);
            } else {
                setNavClass("");
                setImglight(true);
            }
        };

        // componentDidMount
        window.addEventListener("scroll", scrollNavigation, true);

        // componentWillUnmount (cleanup function)
        return () => {
            window.removeEventListener("scroll", scrollNavigation, true);
        };
    }, []); // Array kosong [] memastikan efek ini hanya dijalankan sekali saat komponen dimount

    const Loader = () => {
        return (
            <div id="preloader">
                <div id="status">
                    <div className="spinner">Loading...</div>
                </div>
            </div>
        );
    }

    return (
        <>
            <Suspense fallback={<Loader />} >
                <NavbarPage navItems={navItems} navclassName={navClass} />
                <Section />
                <About />
                <FormRegister />
                <Footer />
            </Suspense>
        </>
    )
}

export default Index;